import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withHashLocation,
  withPreloading,
} from '@angular/router';

import { ApiService } from '@core/http/http.service';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { errorInterceptor } from '@core/interceptors/error.interceptor';
import { loaderInterceptor } from '@core/interceptors/loader.interceptor';
import { planExpiryInterceptor } from '@core/interceptors/plan-expiry.interceptor';
import { NetworkAwarePreloadStrategy } from '@core/services/loading-strategies.service';
import { TitleService } from '@core/services/title.service';
import { TrimInputDirective } from '@shared/directives/trim.directive';

import { routes } from './app.routes';
import { ThemeService } from '@shared/services/theme.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withInterceptors([authInterceptor, errorInterceptor, loaderInterceptor, planExpiryInterceptor])
    ),
    provideRouter(
      routes,
      withPreloading(NetworkAwarePreloadStrategy),
      withHashLocation()
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),

    // App-wide services
    TrimInputDirective,
    ApiService,
    TitleService,
    ThemeService,
    NetworkAwarePreloadStrategy,
  ],
};
